<mat-accordion>
  @if (!sponsor_key) {
    <div class="spacer" style="aspect-ratio: 9 / 1; padding: 1px;"></div>
  }
  @if (sponsor_key) {
    <app-sponsor-banner [location]="location" [sponsor_key]="sponsor_key" [aspect_ratio]="'9:1'"></app-sponsor-banner>
  }
  <mat-expansion-panel hideToggle="true" expanded="true" disabled="true">
    <ng-template matExpansionPanelContent>
      @for (item of set_stats; track item) {
        @if (getStat(item, 'team1') || getStat(item, 'team2')) {
          <div class="row">
            <div>{{ getStat(item, 'team1') }}</div>
            <app-app-string style="text-transform: capitalize" [match_stats_string]="item" [stats_by_set]="true"></app-app-string>
            <div>{{ getStat(item, 'team2') }}</div>
          </div>
        }
      }
    </ng-template>
  </mat-expansion-panel>
</mat-accordion>